import { ApiService } from './api/api'

export default class DocumentService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all document types
	 * @returns Promise
	 */
	create(value): Promise<any> {
		return this.apiService.post('/documents', value)
	}

	/**
	 * Get documents whose latest revision is awaiting the current user's approval.
	 */
	requiringApproval(): Promise<any> {
		return this.apiService.get('/documents/requiring-approval')
	}

	/**
	 * Soft delete a document
	 * @param id The ID of the document to delete
	 * @returns Promise
	 */
	delete(id: number | string): Promise<any> {
		return this.apiService.delete(`/documents/${id}`)
	}

	/**
	 * Add a revision to a document
	 * @param id The ID of the document
	 * @param value The revision data
	 * @returns Promise
	 */
	addRevision(
		id: number | string,
		value: { revision_no: string; date: string; description: string; file: any }
	): Promise<any> {
		return this.apiService.post(`/documents/${id}/revisions`, value)
	}

	/**
	 * Review a document revision (approve or reject)
	 * @param documentId The ID of the document
	 * @param revisionId The ID of the revision being reviewed
	 * @param value The review data
	 * @returns Promise
	 */
	reviewRevision(
		documentId: number | string,
		revisionId: number | string,
		value: { review_status: 'approved' | 'rejected'; review_comments?: string | null }
	): Promise<any> {
		return this.apiService.post(
			`/documents/${documentId}/revisions/${revisionId}/review`,
			value
		)
	}

	/**
	 * Add a link to a document
	 * @param id The ID of the document
	 * @param value The link data
	 * @returns Promise
	 */
	addLink(
		id: number | string,
		value: { product_id: string | number; page_number: number; description: string }
	): Promise<any> {
		return this.apiService.post(`/documents/${id}/links`, value)
	}

	/**
	 * Update a link
	 * @param documentId The ID of the document
	 * @param linkId The ID of the link
	 * @param value The link data
	 * @returns Promise
	 */
	updateLink(
		documentId: number | string,
		linkId: number | string,
		value: { product_id: string | number; page_number: number; description: string }
	): Promise<any> {
		return this.apiService.put(`/documents/${documentId}/links/${linkId}`, value)
	}

	/**
	 * Delete a link
	 * @param documentId The ID of the document
	 * @param linkId The ID of the link
	 * @returns Promise
	 */
	deleteLink(documentId: number | string, linkId: number | string): Promise<any> {
		return this.apiService.delete(`/documents/${documentId}/links/${linkId}`)
	}

	/**
	 * Get links for a document
	 * @param id The ID of the document
	 * @returns Promise
	 */
	getLinks(id: number | string): Promise<any> {
		return this.apiService.get(`/documents/${id}/links`)
	}
}
